module.exports = __webpack_public_path__ + "static/media/logo_atrio.5b97e8c0.svg";